var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('g',{staticStyle:{"font-family":"'alphatab-font'","font-size":"36px"},attrs:{"transform":_vm.source.type === 'tab-linear' ?
      'translate(0,'+_vm.topMargin+')' : ''},domProps:{"innerHTML":_vm._s(_vm.source.svgImage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }